// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
//   projectId: "YOUR_PROJECT_ID",
//   storageBucket: "YOUR_PROJECT_ID.appspot.com",
//   messagingSenderId: "YOUR_SENDER_ID",
//   appId: "YOUR_APP_ID",
    apiKey: "AIzaSyCq2MMgk8oxzgMonj9vQFQzwp0ibzvZwKo",
    authDomain: "milkprofarmerapp.firebaseapp.com",
    projectId: "milkprofarmerapp",
    storageBucket: "milkprofarmerapp.firebasestorage.app",
    messagingSenderId: "723976256430",
    appId: "1:723976256430:web:ac7ca05b139360ffbc663f"
};

const app = initializeApp(firebaseConfig);

// 🔐 Auth
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

// 🔔 Messaging
export const messaging = getMessaging(app);
export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      // vapidKey: "YOUR_PUBLIC_VAPID_KEY_FROM_FIREBASE",
      vapidKey: "BICujtN1uqfw1UtNX-wg5btFlM2gm0p1Q8sycC_k5-vdhjC0YtVwWWdVv6mFSaDYvMZxla0nzRn5FQ0epZmtN4Q"
    });
    if (currentToken) {
      console.log("FCM Token:", currentToken);
      // alert("FCM Token: " + currentToken);
      return currentToken;
    } else {
      console.warn("No registration token available. Request permission.");
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Message received: ", payload);
      resolve(payload);
    });
  });
